import { render, staticRenderFns } from "./modalFullfilmentDetail.vue?vue&type=template&id=7f1f20ca&scoped=true"
import script from "./modalFullfilmentDetail.vue?vue&type=script&lang=js"
export * from "./modalFullfilmentDetail.vue?vue&type=script&lang=js"
import style0 from "./modalFullfilmentDetail.vue?vue&type=style&index=0&id=7f1f20ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f20ca",
  null
  
)

export default component.exports